import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./locationSubTile.css";
import { MdDeleteOutline } from "react-icons/md";
import { useAppDispatch } from "../../redux/hooks";
import { tileColours } from "../../config/colors";

import api from "../../redux/slices/api.slice";
import { HiOutlineTicket } from "react-icons/hi";
import PermissionAction from "../permissions/PermissionAction";
import {
  deleteFloor,
  resetGetFloorsStatus,
} from "../../redux/slices/groups.slice";
import { floorType } from "../../interfaces/groups";
import { useParams } from "react-router-dom";
import { FiBookmark } from "react-icons/fi";
import { IoClose } from "react-icons/io5";
import { RiSettings4Fill } from "react-icons/ri";
import { FaRegStar } from "react-icons/fa";
import { FaStairs } from "react-icons/fa6";
import { useDeleteFloorMutation } from "../../redux/slices/api.slice";
import { notifications } from "@mantine/notifications";
import AddressIcon from "../../svg/addressIcon";
import { Tooltip, Text, Dialog } from "@mantine/core";
import { FaStar } from "react-icons/fa";
import { Modal } from "@mantine/core";
import ChairIcon from "../../svg/chairIcon";
import WifiIcon from "../../svg/wifiIcon";
import CupIcon from "../../svg/coffeCupIcon";
import MettingsIcon from "../../svg/meetingIocn";
import PrinterIcon from "../../svg/printerIcon";
import WheelChairIcon from "../../svg/weelchairIcon";
import PetIcon from "../../svg/petIcon";
import CouchIcon from "../../svg/couchIcon";
import MuteIcon from "../../svg/muteIcon";

import { favoritesLocsAndFloors } from "../../interfaces/bookmarks";

type PropTypes = {
  floor: floorType;
  favorites: favoritesLocsAndFloors;
  setFavorites: (inp: any) => void;
};

export function LocationSubTile({ floor, favorites, setFavorites }: PropTypes) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const [imageSize, setImageSize] = useState(0);
  const [openPopUp, setOpenPopUp] = useState(false);
  const viewPortRef = useRef<HTMLDivElement>(null);
  const [deleteFloorMutation] = useDeleteFloorMutation();
  const [deleteFloorModal, setDeleteFloorModal] = useState(false);
  const amenitiesData = [
    { label: "Wi-Fi Available", icon: WifiIcon },
    { label: "Coffee Space", icon: CupIcon },
    { label: "Meetings Room", icon: MettingsIcon },
    { label: "Printers", icon: PrinterIcon },
    { label: "Wheelchair Accessible", icon: WheelChairIcon },
    { label: "Pet-friendly", icon: PetIcon },
    { label: "Lounge Area", icon: CouchIcon },
    { label: "Quiet Zones", icon: MuteIcon },
  ];

  const handleFloorDelete = async () => {
    try {
      const result = await deleteFloorMutation({ floorID: floor.id });
      //@ts-ignore
      if (result.data) {
        removeFavoriteFloor();
        dispatch(api.util.invalidateTags(["Locations"]));
       
        dispatch(
          deleteFloor({
            floorID: floor.id,
          })
        );
     
        notifications.show({
          title: "Success",
          message: "Floor deleted successfuly",
          color: "green",
        });
      } else {
        notifications.show({
          title: "Error",
          message: "Floor deleted successfuly",
          color: "red",
        });
      }
    } catch (err) {
      notifications.show({
        title: "Error",
        message: "Floor deleted successfuly",
        color: "red",
      });
    }
    setDeleteFloorModal(false);
  };

  const addfaviouriteFloor = () => {
    setFavorites((prevFavorites) => {
      const newFloors = {
        ...prevFavorites.floors,
        [floor.locationID]: [
          ...(prevFavorites.floors?.[floor.locationID] ?? []),
          floor.id,
        ],
      };
      return {
        ...prevFavorites,
        floors: newFloors,
      };
    });
  };

  const removeFavoriteFloor = () => {
    setFavorites((prev) => {
      const floorsInLoc = prev.floors?.[floor.locationID]?.filter(
        (item) => item !== floor.id
      );
      if (floorsInLoc) {
        if (floorsInLoc.length > 0) {
          return {
            ...prev,
            floors: {
              ...prev.floors,
              [floor.locationID]: floorsInLoc,
            },
          };
        } else {
          const { [floor.locationID]: _, ...updatedFloors } = prev.floors;
          return {
            ...prev,
            floors: updatedFloors,
          };
        }
      }
      return prev;
    });
  };

  const isFavoriteFloor = favorites.floors?.[floor.locationID]?.includes(
    floor.id
  );
  const availbleDesks = floor.capacity - floor.occupied - floor.unavailable;
  const copyToClickBoard = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      setOpenPopUp(true);
      setTimeout(() => {
        setOpenPopUp(false);
      }, 2000);
    } catch (error) {
      console.error("Failed to copy to clipboard:", error);
    }
  };

  return (
    <PermissionAction operation="R" resource="floors">
      <div
        data-cy="floorCard"
        className="relative flex flex-col h-full rounded-3xl px-5 py-6 w-full  border border-solid border-[#D5DAE1]  bg-white "
      >
        <div className="flex gap-2 items-center">
          <div className="relative w-16 h-16 rounded-[50%] bg-lightGray flex justify-center items-center">
            <AddressIcon width="35px" height="35px" />
            <div
              className={`h-5 w-5 border-4 border-white border-solid rounded-[50%] ${
                floor.live ? "bg-success" : "bg-alert"
              } absolute bottom-0 -right-1`}
            />
          </div>

          <h1 className="font-md text-black text-[22px]  flex-1 text-wrap">
            {floor.name}
          </h1>
        </div>
        <div className="bg-grayText4 h-[1.3px] w-full mt-3 " />

        <div className="flex flex-col  justify-center flex-1 my-5">
          <div className="flex  justify-between items-center">
            <div
              className="rounded-lg  bg-lightGray text-grayText3 px-2 py-1 my-1  w-fit flex gap-2 items-center cursor-pointer"
              onClick={() => copyToClickBoard(floor.id)}
            >
              <span>{floor.id}</span>
            </div>
          </div>

          <div className="flex gap-2 my-3 text-grayText3  items-center ">
            <ChairIcon />
            <p>
              <span
                className={` mr-1 font-md ${
                  availbleDesks ? "text-success" : "text-actionLight2"
                }`}
              >
                {availbleDesks}
              </span>
              of {floor.capacity} Desks Available
            </p>
          </div>

          <div className="flex gap-2  items-center max-w-full flex-wrap flex-1">
            {floor.amenities?.map((am) => {
              const icon = amenitiesData.find((el) => el.label === am)?.icon;
              return <IconComp key={am} content={am} Icon={icon} />;
            })}
          </div>
        </div>

        <div className="flex  items-end gap-4  ">
          <button
            onClick={() => {
              navigate(`${floor.id}`);
            }}
            data-cy={floor.id === "c04bb" && "selectedViewFloor"}
            className="flex-1   h-fit hover:bg-action rounded-[100px] font-md  hover:text-white py-3 text-md bg-actionLight text-action"
          >
            View Floor
          </button>
          <PermissionAction operation="U" resource="floors">
            <Tooltip label="Floor Settings" withArrow>
              <div
                data-cy={floor.id === "c04bb" && "selectedFloor"}
                onClick={() =>
                  navigate(`/editFloor/${floor.locationID}/${floor.id}`)
                }
                className={`rounded-[50%] w-10 h-10 flex bg-actionLight text-action hover:bg-action hover:text-actionLight  justify-center items-center   text-2xl cursor-pointer`}
              >
                <RiSettings4Fill />
              </div>
            </Tooltip>
          </PermissionAction>
          {isFavoriteFloor ? (
            <div
              onClick={removeFavoriteFloor}
              className={`rounded-[50%] w-10 h-10 flex bg-actionLight text-action justify-center items-center   text-xl cursor-pointer`}
            >
              <FiBookmark fill="#FB6514" />
            </div>
          ) : (
            <div
              onClick={addfaviouriteFloor}
              className={`rounded-[50%] w-10 h-10 flex border border-solid border-grayText3 text-grayText3 bg-white justify-center items-center   text-xl cursor-pointer`}
            >
              <FiBookmark />
            </div>
          )}
        </div>

        <Modal
          opened={deleteFloorModal}
          onClose={() => {
            setDeleteFloorModal(false);
          }}
        >
          <div className="px-2">
            <h4 className=" text-lg font-medium">
              Are you sure you want to delete this Floor !
            </h4>
            <div className="flex gap-4 mt-5 justify-end">
              <button
                className=" border-action border-solid border text-action bg-white hover:bg-actionLight"
                onClick={() => {
                  setDeleteFloorModal(false);
                }}
              >
                Cancel delete
              </button>
              <button
                className="bg-action text-white hover:bg-actionDark"
                onClick={handleFloorDelete}
              >
                Confirm delete
              </button>
            </div>
          </div>
        </Modal>
        <Dialog
          opened={openPopUp}
          size="lg"
          radius="md"
          style={{ background: "#EEF0F3", color: "#4D5F7A" }}
        >
          <Text size="md" fw={500}>
            copied to clickboard
          </Text>
        </Dialog>
      </div>
    </PermissionAction>
  );
}

export function LocationsTilesSpacer() {
  return <div className="locationTile_container" style={{ height: 0 }} />;
}

export default LocationSubTile;

const IconComp = ({ content, Icon }) => {
  return (
    <Tooltip label={content} withArrow>
      <div className="p-3 rounded-[50%] bg-lightGray flex justify-center items-center">
        <Icon />
      </div>
    </Tooltip>
  );
};
